<template>
<CLink @click="setLevel(level.value)" class="btn btn-lg btn-light" :class="active ? 'btn-instagram' : ''">
    {{ level.name }}
</CLink>
</template>

<script>
export default {
    name: 'LevelBtn',

    props: {
        level: {
            required: true,
            type: Object
        },
        active: {
            default: false
        },
    },

    methods: {
        setLevel(levelValue) {
            this.$emit('click', levelValue)
        }
    }
}
</script>